import * as logger from '../utils/logger';
import * as messageInterceptor from '../utils/message-interceptor';
import { createRealJoinTimeMark } from './youbora';
import { getKeyValues } from './config';
import { messages } from '../constants';
import { ROUTES } from '../constants/routes';

const instance = cast.framework.CastReceiverContext.getInstance();
const playerManager = instance.getPlayerManager();
const log = logger.create('ParentalControl');
let isPinAlreadyRequested = false;

/**
 * Checks if content needs PIN permission.
 * @param {Boolean} isPinRequired Indicates if PIN is required or not.
 * @returns {string} Route to be displayed.
 */
export function checkParentalControl(isPinRequired) {
  if (getKeyValues().parentalPinNoCached || !isPinAlreadyRequested) {
    if (isPinRequired) {
      log.info('RequestPin broadcasted');
      playerManager.pause();
      messageInterceptor.broadcast(messages.requestPin);
      return ROUTES.pin;
    } else {
      setPinAlreadyRequested(true);
      createRealJoinTimeMark();
      playerManager.play();
      return ROUTES.playerLive;
    }
  }
}

/**
 * Sets if PIN was already requested from mobile or if playback stops
 * @param {Boolean} isRequested Indicates if PIN is required or not.
 */
export function setPinAlreadyRequested(isRequested) {
  isPinAlreadyRequested = isRequested;
}

/**
 * Gets if PIN was alredy used.
 * @param {Boolean} isPinRequired Indicates if PIN is required or not.
 */
export function getPinAlreadyRequested() {
  return isPinAlreadyRequested;
}
